// extracted by mini-css-extract-plugin
export default {"cls1":"PingAnswerStyles-cls1_KoQ","cls2":"PingAnswerStyles-cls2_hoV PingAnswerStyles-cls1_KoQ"};